/*
File Name: Book.js
Author: Dahlin Carneiro
Modified On: 08/06/2022
Description:Book cover section module.
*/
import { Alert, Col, Image } from "antd";
import { useAuth } from "../../../globalFunctions/AuthContext";
const Book = () => {
	const { cardData } = useAuth();
	return (
		<Col
			lg={{
				span: 24,
				offset: 0
			}}
			xl={{
				span: 8,
				offset: 1
			}}
			className="book-col flex-middle">
			<div>
				{(cardData?.type === 1 || cardData?.type === 2) && (
					<div className="d-sm-none maintain-txt-m mb-5">
						<Alert
							description={<div dangerouslySetInnerHTML={{ __html: cardData?.message }}/>}
							type={cardData.type === 1 ? "error" : "warning"}
						/>
					</div>
				)}
				<Image src="imgs/slp-6th-edition.png" alt="SLP 6th edition" preview={false}/>
			</div>
		</Col>
	);
};
export default Book;